/*
 * @Descripttion: 新增物料页面快捷拾取弹框
 * @Author: cb4786
 * @Date: 2023-09-01 11:19:21
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-28 09:31:23
 */
import React from 'react'
import Style from '../../goodsmanage.module.scss'
import { Button, Form, Input, Modal, Spin } from 'antd'
import { validatorExtractUrl } from '../../../../tools/util'
import { Props } from './hooks'
import UseSheibeiModalHook from './hooks'

const ShibeiModal: React.FC<Props> = (props) => {
  const { hookstate, closeExtractModal } = props
  const { shibeiType, extractVisible } = hookstate
  const {
    state,
    extractForm,
    handleCancelExtractModal,
    reTryShibeiUrlHandel,
    handleConfirmExtractModal,
    handleCloseResult,
  } = UseSheibeiModalHook(props)
  const { extractLoadingVisible, extractResult, extractResultText } = state

  return (
    <Modal
      title={shibeiType === 'pic' ? '链接取图' : '快捷拾取'}
      width={550}
      destroyOnClose
      open={extractVisible}
      keyboard={false}
      maskClosable={false}
      style={{ top: '25%' }}
      onCancel={handleCancelExtractModal}
      footer={
        extractLoadingVisible && extractResult ? (
          <div style={{ textAlign: 'right' }}>
            <Button
              style={{ width: '80px' }}
              size="middle"
              onClick={closeExtractModal}
            >
              取消
            </Button>
            <Button
              style={{ width: '80px' }}
              size="middle"
              type="primary"
              onClick={reTryShibeiUrlHandel}
            >
              重试
            </Button>
          </div>
        ) : extractLoadingVisible ? null : (
          <div style={{ textAlign: 'right' }}>
            <Button size="middle" onClick={handleCancelExtractModal}>
              取消
            </Button>
            <Button
              type="primary"
              size="middle"
              onClick={handleConfirmExtractModal}
            >
              提交
            </Button>
          </div>
        )
      }
      bodyStyle={{ padding: extractResult ? '30px 10px 0' : '16px' }}
    >
      {extractLoadingVisible ? (
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          {extractResult ? (
            <span style={{ fontSize: '16px', fontWeight: 'bolder' }}>
              {extractResultText}
            </span>
          ) : (
            <>
              <Spin />
              <span style={{ display: 'block', margin: '20px 0' }}>
                正在拾取，请稍等......
              </span>
              <Button type="link" onClick={handleCloseResult}>
                关闭
              </Button>
            </>
          )}
        </div>
      ) : (
        <Form form={extractForm}>
          <Form.Item
            name="url"
            label="外链地址"
            rules={[
              {
                required: true,
                validator: validatorExtractUrl,
              },
            ]}
          >
            <Input.TextArea
              style={{ height: 80, resize: 'none' }}
              placeholder="请输入完整地址"
            />
          </Form.Item>
          <span className={Style['extract-tip']}>
            *支持平台：京东、天猫
          </span>
        </Form>
      )}
    </Modal>
  )
}
export default ShibeiModal
/*
 * @Descripttion: 新增物料页面快捷拾取弹框
 * @Author: cb4786
 * @Date: 2023-09-01 11:19:21
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-28 09:31:23
 */
import React from 'react'
import Style from '../../goodsmanage.module.scss'
import { Button, Form, Input, Modal, Spin } from 'antd'
import { validatorExtractUrl } from '../../../../tools/util'
import { Props } from './hooks'
import UseSheibeiModalHook from './hooks'

const ShibeiModal: React.FC<Props> = (props) => {
  const { hookstate, closeExtractModal } = props
  const { shibeiType, extractVisible } = hookstate
  const {
    state,
    extractForm,
    handleCancelExtractModal,
    reTryShibeiUrlHandel,
    handleConfirmExtractModal,
    handleCloseResult,
  } = UseSheibeiModalHook(props)
  const { extractLoadingVisible, extractResult, extractResultText } = state

  return (
    <Modal
      title={shibeiType === 'pic' ? '链接取图' : '快捷拾取'}
      width={550}
      destroyOnClose
      open={extractVisible}
      keyboard={false}
      maskClosable={false}
      style={{ top: '25%' }}
      onCancel={handleCancelExtractModal}
      footer={
        extractLoadingVisible && extractResult ? (
          <div style={{ textAlign: 'right' }}>
            <Button
              style={{ width: '80px' }}
              size="middle"
              onClick={closeExtractModal}
            >
              取消
            </Button>
            <Button
              style={{ width: '80px' }}
              size="middle"
              type="primary"
              onClick={reTryShibeiUrlHandel}
            >
              重试
            </Button>
          </div>
        ) : extractLoadingVisible ? null : (
          <div style={{ textAlign: 'right' }}>
            <Button size="middle" onClick={handleCancelExtractModal}>
              取消
            </Button>
            <Button
              type="primary"
              size="middle"
              onClick={handleConfirmExtractModal}
            >
              提交
            </Button>
          </div>
        )
      }
      bodyStyle={{ padding: extractResult ? '30px 10px 0' : '16px' }}
    >
      {extractLoadingVisible ? (
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          {extractResult ? (
            <span style={{ fontSize: '16px', fontWeight: 'bolder' }}>
              {extractResultText}
            </span>
          ) : (
            <>
              <Spin />
              <span style={{ display: 'block', margin: '20px 0' }}>
                正在拾取，请稍等......
              </span>
              <Button type="link" onClick={handleCloseResult}>
                关闭
              </Button>
            </>
          )}
        </div>
      ) : (
        <Form form={extractForm}>
          <Form.Item
            name="url"
            label="外链地址"
            rules={[
              {
                required: true,
                validator: validatorExtractUrl,
              },
            ]}
          >
            <Input.TextArea
              style={{ height: 80, resize: 'none' }}
              placeholder="请输入完整地址"
            />
          </Form.Item>
          <span className={Style['extract-tip']}>
            *支持平台：京东、天猫
          </span>
        </Form>
      )}
    </Modal>
  )
}
export default ShibeiModal
